import { Button, Stack, TextField, Typography } from "@mui/material";
import DrawerFiltersComponent from "../../../components/drawer-filters";
import { IBranchCreate } from "../../../types/branch";
import { ChangeEvent } from "react";

type Props = {
    canReset: boolean;
    open: boolean;
    onClose: VoidFunction;
    onOpen: VoidFunction;
    resetFilters: VoidFunction;
    filters: IBranchCreate;
    handleFilters: (name: string, value: string) => void;
    getResults: VoidFunction;
}

const BranchFiltersComponent = ({ canReset, open, onClose, onOpen, resetFilters, filters, handleFilters, getResults }: Props) => {

    return (
        <DrawerFiltersComponent
            canReset={canReset}
            open={open}
            onClose={onClose}
            onOpen={onOpen}
            resetFilters={resetFilters}
        >
            <>
                <Stack>
                    <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                        Código
                    </Typography>
                    <TextField
                        placeholder="Código da filial"
                        value={filters.code}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleFilters('code', e.target.value)}
                    />
                </Stack>
                <Stack>
                    <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                        Nome
                    </Typography>
                    <TextField
                        placeholder="Nome da filial"
                        value={filters.name}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleFilters('name', e.target.value)}
                    />
                </Stack>
                <Stack sx={{ mt: 3 }}>
                    <Button variant="contained" onClick={() => {
                        getResults();
                        onClose();
                    }}>
                        Pesquisar
                    </Button>   
                </Stack>
            </>
        </DrawerFiltersComponent>
    )

}

export default BranchFiltersComponent;